import { createFileRoute } from '@tanstack/react-router'
import { accountSearchSchema, healthQueryOptions } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/account')({
  validateSearch: (search) => accountSearchSchema.parse(search),
  loaderDeps: () => ({}),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    layout: 'menu',
  },
})
